import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import YoutubeEmbedVideo from "youtube-embed-video";
import pic11 from '../../assets/images/queen-hms-elizabeth.jpg'

const HMSQueenElizabethPost = (props) => (
    <div>
        <Helmet>
            <title>HMS Queen Elizabeth | Warship Biggest | News</title>
            <meta name="description" content="Designed to represent Britain’s post-Brexit new era in maritime power, the HMS Queen Elizabeth has nevertheless been met 
            with the scepticism of former officers from the military who claim it 
            can only ever be a “totemic symbol” which will be rapidly overtaken by the latest cutting edge technology." />
        </Helmet>

        <div id="main" className="alt">
            <section id="one">
                <div className="inner">
                    <header className="major">
                        <h1>HMS Queen Elizabeth</h1>
                    </header>
                    <p>Was It Necessary?</p>
                    <span className="image main"><img src={pic11} alt="" /></span>
                    <p>Portsmouth recently saw the arrival of the biggest warship to ever have been built for the UK arrive in its port, however, 
                    its arrival also saw a raft of criticism for the aircraft carrier, which cost £3 billion.</p>
                    
                    <p>Designed to represent Britain’s post-Brexit new era in maritime power, the HMS Queen Elizabeth has nevertheless been met 
                    with the scepticism of former officers from the military who claim it 
                    can only ever be a “totemic symbol” which will be rapidly overtaken by the latest cutting edge technology. </p>

                    <h2>An impressive display</h2>
                    

                    <YoutubeEmbedVideo videoId="UubiTA6R6_w" 
                                       suggestions={false}
                                       width="100%"
                                       height="450px"  />
                    <br/>
                    <br/>

                    <p>Hailed by prime minister Theresa May as a potent and versatile asset capable of combating the threats of today, the warship was received 
                    in the city by thousands of spectators who came to witness the historic moment. Jets and helicopters flew overhead while a flotilla 
                    of accompany ships sailed alongside, and crowds were entertained by the Royal Marines band.</p>
                    <p>The HMS Queen Elizabeth is purportedly going to take a message of prosperity and partnership from a post-Brexit UK to the 
                    world’s rising economies. As an embodiment of the nation’s spirit, the future flagship of the nation is designed to project an outward 
                    looking and confident stance to the rest of the globe, despite the fact that its sister ship, the HMS Prince of Wales has not yet been 
                    finished followed many delays in the 20 years the project has taken to reach fruition.</p>

                    <hr/>
                    <h3>A vulnerable target</h3>
                    <p>The 65,000 tonne, 919 foot-long ship has been tested at sea but as yet, there are no set dates for its operations to begin. 
                    Its 14 jets will not even begin their trial flights until 2019. It may be no wonder, then, that the Government have been accused of prioritising 
                    these two aircraft carriers ahead of more conventional forces at the same time as limiting the nation’s defence budget. 
                    Billions have been plunged into these high-profile warships while cuts are 
                    expected to the Royal Marines and Army, thus weakening the country’s overall military stance.</p>

                    <p>Added into the mix comes the report that was recently published by Dr Roberts, military sciences director at the RUSI which warned of the 
                    vulnerability of modern aircraft carriers to missile attacks from North Korea, China and Russia. In fact, Russia have already 
                    describe the project as a large and convenient target.</p>

                    <hr/>
                    
                    <h3>A waste of assets?</h3>
                    <p>During its operations, the HMS Queen Elizabeth is set to receive the protection of F-35 Lightning II stealth jets, destroyers, a submarine, 
                    frigates and Crowsnest helicopters – all assets that critics claim could better be used elsewhere. The nature of modern warfare has dramatically<br/>
                    changed since the concept of the two warships was developed back in the late 1990s, and with news that a £300 drone was landed by an amateur 
                    photographer on the HMS Queen Elizabeth’s deck, this does not bode well for the nation’s defence.</p>

                    <p>Of course, the military deny that the flagship is a waste of money, stating that it will be a strong asset to the nation. 
                    The truth of the matter will only be seen in time.</p>
                    
                    <a href="/#header" className="button">BACK HOME</a>
                </div>
            </section>
        </div>

    </div>
)

export default HMSQueenElizabethPost


// WEBPACK FOOTER //
// ./src/pages/news/hms-queen-elizabeth.js